import React from "react";
import * as NWD from "../style/tjanster-infopage-style";
import * as Lib from "../style/lib";
import { AndtechWebSkills } from "../utils/skill-webbutveckling";
import { BokaMote } from "../style/bokaMote";
import JL from "../../assets/portraits/JL_portrait.jpg";

export const Webbutveckling: React.FC = () => {
  return (
    <NWD.WebDevSection>
      <Lib.Headertop>Tjänster – Webbutveckling</Lib.Headertop>
      <Lib.BigH1>Webbutveckling</Lib.BigH1>
      <NWD.ServiceTextSection>
      <NWD.WebDevParagraphIntro>
        {`Behöver du ett team som både bygger din hemsida och ser till att den mår bra i längden?`}
      </NWD.WebDevParagraphIntro>

      <NWD.WebDevParagraph>
        {`Vi skapar snabba, snygga och användarvänliga webbplatser som fungerar smidigt på alla enheter. Med fokus på prestanda, SEO och en genomtänkt användarupplevelse bygger vi en sida som gör jobbet – oavsett om målet är fler kunder, bättre synlighet eller en starkare digital närvaro.
        
        Men en bra hemsida handlar om mer än bara kod och design. Det handlar om rätt strategi, tydliga budskap och en smidig användarresa som guidar besökaren dit du vill. Därför tänker vi inte bara på hur sidan ser ut, utan också på hur den känns att använda.
        
        När hemsidan är redo att möta världen hjälper vi dig vidare med lansering, uppdateringar och allt som krävs för att den ska fortsätta prestera. En stabil partner, helt enkelt.

        Vill du ha en webbplats som jobbar för dig – och en partner som finns med hela vägen? Låt oss ses och prata om vad du behöver!`
        }
      </NWD.WebDevParagraph>
      </NWD.ServiceTextSection>

      <AndtechWebSkills />
      
      <BokaMote 
          name="Johanna" 
          img={JL} 
          text="Boka ett möte med {name}." 
          email="hello@antech.se"
          subject="Bokningsförfrågan: Möte med Johanna"
          body="Hej Johanna, Jag är intresserad av att veta mer om webbutveckling och skulle gärna boka ett möte med dig."
      />
    </NWD.WebDevSection>
  );
};
